module.exports = __webpack_public_path__ + "media/customizations/regencyattracylakes/logo-06f2d32a1d77abcf02182365825e4321.png";